import { useLang } from "@/i18n";
import { Reveal, ChapterTag } from "./Reveal";

export default function Process() {
  const { t } = useLang();
  return (
    <section id="process" data-testid="process-section" className="max-w-7xl mx-auto px-6 lg:px-10 py-24 md:py-32">
      <Reveal>
        <ChapterTag num="03" label={t("ch_process")} />
        <h2 className="font-display font-extrabold text-3xl md:text-4xl lg:text-5xl tracking-tight">{t("process_title")}</h2>
      </Reveal>
      <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-4 gap-10">
        {t("process_steps").map((s, i) => (
          <Reveal key={s.t} delay={i * 0.12}>
            <div className="relative group" data-testid={`process-step-${i}`}>
              <span className="font-display text-7xl font-black text-gold/15 leading-none transition-colors duration-500 group-hover:text-gold/30 select-none">
                {String(i + 1).padStart(2, "0")}
              </span>
              <div className="mt-4 h-px w-full bg-gradient-to-r from-gold/40 to-transparent" />
              <h3 className="mt-5 font-display font-bold text-xl">{s.t}</h3>
              <p className="mt-2 text-sm text-white/55 leading-relaxed">{s.d}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
